import * as React from "react";
import * as program from "../program.module.scss";

export const programData = [
  {
    theme: "«Фонетика английского языка»",
    explanation:
    <>
      <h3>Блок 1</h3>
      <ul>
        <li>Изучение технологий.</li>
        <li>Простейшие гласные и согласные звуки.</li>
        <li>Чтение транскрипции.</li>
        <li>Простые звуки, состоящие из двух элементов.</li>
      </ul>

      <h3>Блок 2</h3>
      <ul>
        <li>Звуки, которые не имеют аналога в русском языке.</li>
        <li>Первые буквосочетания.</li>
      </ul>

      <h3>Блок 3</h3>
      <ul>
        <li>Сложные буквосочетания.</li>
      </ul>

      <h3>Блок 4</h3>
      <ul>
        <li>Исключения.</li>
      </ul>

      <h3>Блок 5</h3>
      <ul>
        <li>Правила постановки ударений.</li>
      </ul>

      <div className={program.note}>
        Каждый блок завершается тестом.
      </div>
    </>
  },
  {
    theme: "Структура урока фонетики",
    explanation:
    <>
      <ol>
        <li>Разминка для мозга.</li>
        <li>Обучающее видео.</li>
        <li>Тренажёр «Паттерны» для отработки нового звука или буквосочетания.</li>
        <li>Упражнения на отработку звуков и буквосочетаний.</li>
        <li>Тест.</li>
        <li>Дополнительная практика:
          <ul>
            <li>диалоги,</li>
            <li>скороговорки,</li>
            <li>чтение слов с изучаемыми звуками и буквосочетаниями,</li>
            <li>чтение предложений.</li>
          </ul>
        </li>
      </ol>
    </>
  },
  {
    theme: "«Английский для ваших целей. Starter + Beginner (А1)»",
    explanation:
    <>
      <ol>
        <li>Входное тестирование.</li>
        <li>Вводный блок (18 уроков):
          <ul>
            <li>изучение технологий ускоренного обучения,</li>
            <li>изучение и отработка базовой лексики для начинающих с помощью мнемотехник,</li>
            <li>простые тексты из этих же слов, которые позволяют закрепить новые слова и повторить ранее выученные.</li>
          </ul>
        </li>
        <li>Основной блок (42 урока):
          <ul>
            <li>разминка для мозга в начале каждого урока,</li>
            <li>изучение лексики на мнемотехниках,</li>
            <li>изучение грамматики на майнд-картах,</li>
            <li>5 промежуточных тестов с выводом грамматики и лексики в актив.</li>
          </ul>
        </li>
        <li>Итоговое тестирование.</li>
        <li>Дополнительно: 250 слов на готовых ассоциациях.</li>
      </ol>
    </>
  },
  {
    theme: "«Английский для ваших целей. Elementary (A2)»",
    explanation:
    <>
      <ol>
        <li>Входное тестирование.</li>
        <li>Вводный блок (15 уроков):
          <ul>
            <li>изучение технологий ускоренного обучения,</li>
            <li>изучение и отработка базовой лексики уровня,</li>
            <li>повторение основных грамматических структур начинающего уровня,</li>
            <li>тестирование.</li>
          </ul>
        </li>
        <li>Основной блок (47 уроков):
          <ul>
            <li>разминка для мозга в начале каждого урока,</li>
            <li>изучение лексики на мнемотехниках,</li>
            <li>изучение грамматики на майнд-картах,</li>
            <li>4 промежуточных тестирования.</li>
          </ul>
        </li>
        <li>Итоговое тестирование.</li>
        <li>  Дополнительный блок (10 уроков):
          <ul>
            <li>изучение дополнительной лексики,</li>
            <li>изучение дополнительной грамматики.</li>
          </ul>
        </li>
      </ol>
    </>
  },
  {
    theme: "«Английский для ваших целей. Уровень Profi (B1)»",
    explanation:
    <>
      <ol>
        <li>Вводный блок (10 разделов, в среднем по 4 темы в каждом разделе):
          <ul>
            <li>изучение технологий,</li>
            <li>изучение и повторение лексики предыдущего уровня,</li>
            <li>изучение и повторение грамматики уровня Elementary,</li>
            <li>тестирование.</li>
          </ul>
        </li>
        <li>Основной блок (21 раздел, по 8 тем в каждом разделе):
          <ul>
            <li>изучение лексики,</li>
            <li>изучение грамматики,</li>
            <li>тестирование в каждом разделе.</li>
          </ul>
        </li>
      </ol>
    </>
  },
  {
    theme: "«Английский для ваших целей. Уровень Profi+ (B2)»",
    explanation:
    <>
      <p>11 разделов, в среднем по 6 тем в каждом разделе:</p>
      <ul>
        <li>введение,</li>
        <li>изучение лексики,</li>
        <li>изучение грамматики,</li>
        <li>тесты после каждого раздела,</li>
        <li>итоговый тест.</li>
      </ul>
    </>
  },
  {
    theme: "Структура урока в курсах",
    explanation:
    <>
      <ol>
        <li>Разминка для мозга в каждом уроке (тренировка памяти, внимания).</li>
        <li>Аудиопаттерны для повторения изученного и первого знакомства с новым материалом.</li>
        <li>Обучающее видео.</li>
        <li>Тренажёр «Паттерны» для отработки и автоматизации нового материала. Представлен в 3-х уровнях  сложности, между которыми можно переключаться.</li>
        <li>Коммуникативные упражнения для закрепления изученного.</li>
        <li>Тест.</li>
        <li>Дополнительные активности:
          <ul>
            <li>упражнения на развитие навыков чтения,</li>
            <li>упражнения на развитие навыков аудирования,</li>
            <li>повторение слов по принципу воронки,</li>
            <li>тренажёр Spritz.</li>
          </ul>
        </li>
      </ol>
    </>
  }
]
